import Axios, { AxiosRequestConfig } from "axios";
import { digiAccGuiStates, digiAccGuiTypes, digiAccTypes } from "../common/TextTypes";
import { IFileSortItem, ISourceDocumentCreateModel, ISourceDocumentMarkCompletedModel, ISourceDocumentModel, ISourceDocumentModifyModel, ISourceDocumentStatisticsModel, ISourceDocumentTypeStatisticsModel } from "./model/ISourceDocumentModel";
import PageResult from "./rest_api_connection/PageResult";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class SourceDocumentService extends ServiceBase {

    public async getSourceDocuments(
        organizationId?: string,
        page?: number,
        limit?: number,
        voucherDateFrom?: Date,
        voucherDateTo?: Date,
        dueDateFrom?: Date,
        dueDateTo?: Date,
        valueDateFrom?: Date,
        valueDateTo?: Date,
        createdDateFrom?: Date,
        createdDateTo?: Date,
        voucherStatus?: digiAccGuiStates[],
        voucherType?: digiAccGuiTypes,
        invoiceNo?: string,
        debitAccount?: number,
        creditAccount?: number,
        departmentId?: string,
        projectId?: string,
        voucherIdFrom?: string,
        voucherIdTo?: string,
        amountFrom?: string,
        amountTo?: string,
        freeTextSearch?: string,
        sortDocumentField?: IFileSortItem,
    ): Promise<PageResult<ISourceDocumentModel[]>>
    {
        let url = "/Organization/" + organizationId + "/SourceDocument?";
        //let url = "https://localhost:7024/SourceDocument?";
        let terms: string[] = [];
        if (page)
            terms.push("page=" + page);
        if (limit)
            terms.push("limit=" + limit);

        if (voucherDateFrom)
            terms.push("voucherDateFrom=" + voucherDateFrom.getFullYear() + "-" + (voucherDateFrom.getMonth() + 1) + "-" + voucherDateFrom.getDate());
        if (voucherDateTo)
            terms.push("voucherDateTo=" + voucherDateTo.getFullYear() + "-" + (voucherDateTo.getMonth() + 1) + "-" + voucherDateTo.getDate());
        if (dueDateFrom)
            terms.push("dueDateFrom=" + dueDateFrom.getFullYear() + "-" + (dueDateFrom.getMonth() + 1) + "-" + dueDateFrom.getDate());
        if (dueDateTo)
            terms.push("dueDateTo=" + dueDateTo.getFullYear() + "-" + (dueDateTo.getMonth() + 1) + "-" + dueDateTo.getDate());
        if (valueDateFrom)
            terms.push("valueDateFrom=" + valueDateFrom.getFullYear() + "-" + (valueDateFrom.getMonth() + 1) + "-" + valueDateFrom.getDate());
        if (valueDateTo)
            terms.push("valueDateTo=" + valueDateTo.getFullYear() + "-" + (valueDateTo.getMonth() + 1) + "-" + valueDateTo.getDate());
        if (createdDateFrom)
            terms.push("createdDateFrom=" + createdDateFrom.getFullYear() + "-" + (createdDateFrom.getMonth() + 1) + "-" + createdDateFrom.getDate());
        if (createdDateTo)
            terms.push("createdDateTo=" + createdDateTo.getFullYear() + "-" + (createdDateTo.getMonth() + 1) + "-" + createdDateTo.getDate());
        

        if (voucherStatus && !voucherStatus.find(e => e === "All")) {
            voucherStatus.map(e => terms.push("status=" + encodeURIComponent(e)));
        }
        if (voucherType && voucherType !== "All")
            terms.push("type=" + encodeURIComponent(voucherType));
        if (invoiceNo)
            terms.push("invoiceNo=" + encodeURIComponent(invoiceNo));
        if (debitAccount)
            terms.push("debitAccount=" + encodeURIComponent(debitAccount));
        if (creditAccount)
            terms.push("creditAccount=" + encodeURIComponent(creditAccount));
        if (departmentId)
            terms.push("departmentId=" + encodeURIComponent(departmentId));
        if (projectId)
            terms.push("projectId=" + encodeURIComponent(projectId));
        if (voucherIdFrom)
            terms.push("voucherIdFrom=" + encodeURIComponent(voucherIdFrom));
        if (voucherIdTo)
            terms.push("voucherIdTo=" + encodeURIComponent(voucherIdTo));
        if (amountFrom)
            terms.push("amountFrom=" + encodeURIComponent(amountFrom));
        if (amountTo)
            terms.push("amountTo=" + encodeURIComponent(amountTo));
        if (freeTextSearch)
            terms.push("freeText=" + encodeURIComponent(freeTextSearch));
        if (sortDocumentField && sortDocumentField.sort) {
            switch (sortDocumentField.field) {
                case "id":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Id" : "IdDescending"));
                    break;
                case "batchId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "BatchId" : "BatchIdDescending"));
                    break;
                case "invoiceNo":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "InvoiceNo" : "InvoiceNoDescending"));
                    break;
                case "voucherDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "VoucherDate" : "VoucherDateDescending"));
                    break;
                case "dueDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DueDate" : "DueDateDescending"));
                    break;
                case "valueDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ValueDate" : "ValueDateDescending"));
                    break;
                case "debitAccount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DebitAccount" : "DebitAccountDescending"));
                    break;
                case "creditAccount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreditAccount" : "CreditAccountDescending"));
                    break;
                case "department":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DepartmentId" : "DepartmentIdDescending"));
                    break;
                case "project":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ProjectId" : "ProjectId"));
                    break;
                case "comments":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Comments" : "CommentsDescending"));
                    break;
                case "status":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Status" : "StatusDescending"));
                    break;
                case "createdDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreatedDate" : "CreatedDateDescending"));
                    break;
                case "createdBy":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreatedBy" : "CreatedByDescending"));
                    break;
                case "modifiedDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ModifiedDate" : "ModifiedDateDescending"));
                    break;
                case "modifiedBy":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ModifiedBy" : "ModifiedByDescending"));
                    break;
                case "originalSourceDocumentId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "OriginalSourceDocumentId" : "OriginalSourceDocumentIdDescending"));
                    break;
                case "correctionComments":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CorrectionComments" : "CorrectionCommentsDescending"));
                    break;
                case "voucherId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "VoucherId" : "VoucherIdDescending"));
                    break;
                case "source":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Source" : "SourceDescending"));
                    break;
                case "amount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Amount" : "AmountDescending"));
                    break;
                case "type":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Type" : "TypeDescending"));
                    break;
            }
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJsonPaged<ISourceDocumentModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocumentsExcelFile(
        organizationId?: string,
        page?: number,
        limit?: number,
        voucherDateFrom?: Date,
        voucherDateTo?: Date,
        dueDateFrom?: Date,
        dueDateTo?: Date,
        valueDateFrom?: Date,
        valueDateTo?: Date,
        createdDateFrom?: Date,
        createdDateTo?: Date,
        voucherStatus?: digiAccGuiStates[],
        voucherType?: digiAccGuiTypes,
        invoiceNo?: string,
        debitAccount?: number,
        creditAccount?: number,
        departmentId?: string,
        projectId?: string,
        voucherIdFrom?: string,
        voucherIdTo?: string,
        amountFrom?: string,
        amountTo?: string,
        freeTextSearch?: string,
        sortDocumentField?: IFileSortItem,
    ): Promise<Result<Blob>> {
        let url = "/Organization/" + organizationId + "/SourceDocument/DownloadExcel?";

        let terms: string[] = [];
        if (page)
            terms.push("page=" + page);
        if (limit)
            terms.push("limit=" + limit);

        if (voucherDateFrom)
            terms.push("voucherDateFrom=" + voucherDateFrom.getFullYear() + "-" + (voucherDateFrom.getMonth() + 1) + "-" + voucherDateFrom.getDate());
        if (voucherDateTo)
            terms.push("voucherDateTo=" + voucherDateTo.getFullYear() + "-" + (voucherDateTo.getMonth() + 1) + "-" + voucherDateTo.getDate());
        if (dueDateFrom)
            terms.push("dueDateFrom=" + dueDateFrom.getFullYear() + "-" + (dueDateFrom.getMonth() + 1) + "-" + dueDateFrom.getDate());
        if (dueDateTo)
            terms.push("dueDateTo=" + dueDateTo.getFullYear() + "-" + (dueDateTo.getMonth() + 1) + "-" + dueDateTo.getDate());
        if (valueDateFrom)
            terms.push("valueDateFrom=" + valueDateFrom.getFullYear() + "-" + (valueDateFrom.getMonth() + 1) + "-" + valueDateFrom.getDate());
        if (valueDateTo)
            terms.push("valueDateTo=" + valueDateTo.getFullYear() + "-" + (valueDateTo.getMonth() + 1) + "-" + valueDateTo.getDate());
        if (createdDateFrom)
            terms.push("createdDateFrom=" + createdDateFrom.getFullYear() + "-" + (createdDateFrom.getMonth() + 1) + "-" + createdDateFrom.getDate());
        if (createdDateTo)
            terms.push("createdDateTo=" + createdDateTo.getFullYear() + "-" + (createdDateTo.getMonth() + 1) + "-" + createdDateTo.getDate());


        if (voucherStatus && !voucherStatus.find(e => e === "All")) {
            voucherStatus.map(e => terms.push("status=" + encodeURIComponent(e)));
        }
        if (voucherType && voucherType !== "All")
            terms.push("type=" + encodeURIComponent(voucherType));
        if (invoiceNo)
            terms.push("invoiceNo=" + encodeURIComponent(invoiceNo));
        if (debitAccount)
            terms.push("debitAccount=" + encodeURIComponent(debitAccount));
        if (creditAccount)
            terms.push("creditAccount=" + encodeURIComponent(creditAccount));
        if (departmentId)
            terms.push("departmentId=" + encodeURIComponent(departmentId));
        if (projectId)
            terms.push("projectId=" + encodeURIComponent(projectId));
        if (voucherIdFrom)
            terms.push("voucherIdFrom=" + encodeURIComponent(voucherIdFrom));
        if (voucherIdTo)
            terms.push("voucherIdTo=" + encodeURIComponent(voucherIdTo));
        if (amountFrom)
            terms.push("amountFrom=" + encodeURIComponent(amountFrom));
        if (amountTo)
            terms.push("amountTo=" + encodeURIComponent(amountTo));
        if (freeTextSearch)
            terms.push("freeText=" + encodeURIComponent(freeTextSearch));
        if (sortDocumentField && sortDocumentField.sort) {
            switch (sortDocumentField.field) {
                case "id":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Id" : "IdDescending"));
                    break;
                case "batchId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "BatchId" : "BatchIdDescending"));
                    break;
                case "invoiceNo":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "InvoiceNo" : "InvoiceNoDescending"));
                    break;
                case "voucherDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "VoucherDate" : "VoucherDateDescending"));
                    break;
                case "dueDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DueDate" : "DueDateDescending"));
                    break;
                case "valueDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ValueDate" : "ValueDateDescending"));
                    break;
                case "debitAccount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DebitAccount" : "DebitAccountDescending"));
                    break;
                case "creditAccount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreditAccount" : "CreditAccountDescending"));
                    break;
                case "department":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "DepartmentId" : "DepartmentIdDescending"));
                    break;
                case "project":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ProjectId" : "ProjectId"));
                    break;
                case "comments":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Comments" : "CommentsDescending"));
                    break;
                case "status":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Status" : "StatusDescending"));
                    break;
                case "createdDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreatedDate" : "CreatedDateDescending"));
                    break;
                case "createdBy":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CreatedBy" : "CreatedByDescending"));
                    break;
                case "modifiedDate":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ModifiedDate" : "ModifiedDateDescending"));
                    break;
                case "modifiedBy":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "ModifiedBy" : "ModifiedByDescending"));
                    break;
                case "originalSourceDocumentId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "OriginalSourceDocumentId" : "OriginalSourceDocumentIdDescending"));
                    break;
                case "correctionComments":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "CorrectionComments" : "CorrectionCommentsDescending"));
                    break;
                case "voucherId":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "VoucherId" : "VoucherIdDescending"));
                    break;
                case "source":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Source" : "SourceDescending"));
                    break;
                case "amount":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Amount" : "AmountDescending"));
                    break;
                case "type":
                    terms.push("OrderBy=" + encodeURIComponent(sortDocumentField.sort === "asc" ? "Type" : "TypeDescending"));
                    break;
            }
        }

        let termsUrl = terms.join("&");

        var result = await this.requestFile<Blob>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocument(organizationId: string, sourceDocumentId: number, loadExternalData: boolean = true): Promise<Result<ISourceDocumentModel>> {

        let url = `/Organization/${organizationId}/SourceDocument/${sourceDocumentId}?loadExternalData=${loadExternalData}`;

        var result = await this.requestJson<ISourceDocumentModel>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocumentStatistics(

    ): Promise<Result<ISourceDocumentStatisticsModel[]>> {
        let url = "/SourceDocument/Organization/Statistics";

        var result = await this.requestJson<ISourceDocumentStatisticsModel[]>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocumentTypeStatistics(organizationId: string): Promise<Result<ISourceDocumentTypeStatisticsModel>> {
        // Construct the URL using the passed organizationId
        const url = `/Organization/${organizationId}/SourceDocument/Statistics/PendingProcessing`;

        // Make the HTTP GET request using requestJson method
        const result = await this.requestJson<ISourceDocumentTypeStatisticsModel>({
            url: url,
            method: "GET"
        });

        // Return the result
        return result;
    }

    public async postSourceDocumentsCreateAddition(
        organizationId: string, sourceDocumentIds: number[],
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/CreateAddition";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { sourceDocumentIds: sourceDocumentIds }
        });
        return result;
    }

    public async postSourceDocumentsTransfer(
        organizationId: string, sourceDocumentIds: number[],
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/Transfer";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { sourceDocumentIds: sourceDocumentIds }
        });
        return result;
    }

    public async postSourceDocumentsTransferAll(
        organizationId: string, type: "IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement",
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/Transfer/All";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { sourceDocumentType: type }
        });
        return result;
    }

    public async postSourceDocumentReject(
        organizationId: string, sourceDocumentIds: number[],
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/Reject";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { sourceDocumentIds: sourceDocumentIds }
        });
        return result;
    }

    public async postSourceDocumentMarkCompleted(
        organizationId: string, sourceDocumentId: number, ignoreWarnings: boolean
    ): Promise<Result<ISourceDocumentMarkCompletedModel[]>> {
        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/MarkCompleted";

        var result = await this.requestJson<ISourceDocumentMarkCompletedModel[]>({
            url: url,
            method: "POST",
            data: { organizationId: organizationId, sourceDocumentId: sourceDocumentId, ignoreWarnings: ignoreWarnings }
        });
        return result;
    }

    public async postSourceDocumentUndoReject(
        organizationId: string, sourceDocumentIds: number[],
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/UndoReject";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: { sourceDocumentIds: sourceDocumentIds }
        });
        return result;
    }

    public async postSourceDocumentMove(
        organizationId: string, sourceDocumentIds: number[], type: "IncomingInvoice" | "OutgoingInvoice" | "Banking" | "JournalEntries" | "Miscellaneous" | "Addition" | "Cash" | "Statement"
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/Move";

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: {
                destinationDocumentType: type,
                sourceDocumentIds: sourceDocumentIds
            }
        });
        return result;
    }

    public async putSourceDocumentModify(
        organizationId: string, sourceDocumentId: number, comments: string, data: ISourceDocumentModifyModel[]
    ): Promise<DefaultResult> {
        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/Modify";

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: {
                comments: comments,
                setLines: data
            }
        })
        return result;
    }

    public async postSourceDocumentFile(organizationId: string, sourceDocumentId: number, file: File): Promise<DefaultResult> {

        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/File";

        const form = new FormData();
        form.append("file", file);

        var result = await this.sendFormData({
            url: url,
            method: "POST",
            data: form,
        });
        return result;
    }

    public async postSourceDocument(organizationId: string, sourceDocumentType: digiAccTypes, comment: string, fileContents: string, setLines: ISourceDocumentModifyModel[]):
        Promise<Result<ISourceDocumentCreateModel>> {

        let url = "/Organization/" + organizationId + "/SourceDocument";

        var result = await this.requestJson<ISourceDocumentCreateModel>({
            url: url,
            method: "POST",
            data: {
                organizationId: organizationId,
                sourceDocumentType: sourceDocumentType,
                comment: comment,
                fileContents: fileContents,
                setLines: setLines,
            }
        });
        return result;
    }

    public async getSourceDocumentsFilePage(
        organizationId: string,
        sourceDocumentFileId: number,
        page: number,
        sourceDocumentId: string,
    ): Promise<Result<Blob>> {
        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/File/" + sourceDocumentFileId + "/Page/" + page;

        var result = await this.requestFile<Blob>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocumentsFile(
        organizationId: string,
        sourceDocumentFileId: number,
        sourceDocumentId: string,
    ): Promise<Result<Blob>> {
        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/File/" + sourceDocumentFileId;

        var result = await this.requestFile<Blob>({
            url: url,
            method: "GET"
        });
        return result;
    }

    public async getSourceDocumentsFileDownloadPDF(
        organizationId: string,
        sourceDocumentFileId: number,
        sourceDocumentId: string,
    ): Promise<Result<Blob>> {
        let url = "/Organization/" + organizationId + "/SourceDocument/" + sourceDocumentId + "/File/" + sourceDocumentFileId + "/DownloadPDF";

        var result = await this.requestFile<Blob>({
            url: url,
            method: "GET"
        });
        return result;
    }
}